<template>
    <div>
        <ReturnHeader :img_header="header_image" header="ดูรายละเอียดสินค้า" link_back="stock/storage/returnstorage" />
        <v-slide-x-reverse-transition>
            <v-alert type="success" class="alert" v-if="alert_success === true">ย้ายสินค้าสำเร็จ !</v-alert>
        </v-slide-x-reverse-transition>
        <v-card elevation="6">
            <!-- แสดงข้อมูลประเภทเป็นหัวข้อใหญ่ -->
            <div class="pa-6">
                <div class="pa-4" style="font-size: 26px">
                    <div>{{ getTypeName(typeReturn) }}</div>
                </div>
                <v-row>
                    <v-col cols="12" sm="4" md="4">
                        <v-select v-model="selectedMonth" :items="months" item-text="name" item-value="value"
                            label="กรุณาเลือกเดือน" color="#86bc3a" outlined dense clearable></v-select>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-select v-model="selectedYear" :items="years" label="กรุณาเลือกปี" color="#86bc3a" outlined
                            dense clearable></v-select>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <v-btn @click="loadData" class="grad-success-bg white--text" height="40" block>
                            <v-icon left>mdi-magnify</v-icon>
                            ค้นหา
                        </v-btn>
                    </v-col>
                </v-row>
            </div>

            <div v-if="loading_page === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <div v-else class="pa-2">
                <v-card-title>
                    <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line
                        hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="productList" :footer-props="footer_Props" :search="search"
                    mobile-breakpoint="0">
                    <template slot="item" slot-scope="dataDetail">
                        <tr>
                            <td>{{ dataDetail.item.lot_no }}</td>
                            <td>{{ dataDetail.item.product_name }}</td>
                            <td>{{ formatDate(dataDetail.item.date_expired) }}</td>
                            <td>{{ format_number(dataDetail.item.quantity) }}</td>
                            <td>{{ dataDetail.item.unit_name }}</td>
                            <td>
                                <div v-if="dataDetail.item.cause_note !== null">{{ dataDetail.item.cause_note }}</div>
                                <div v-else>-</div>
                            </td>
                            <td>{{ dataDetail.item.supplier_name }}</td>
                            <td class="pa-3">
                                <v-btn
                                    @click="get_move(dataDetail.item.quantity, dataDetail.item.warehouse_id, dataDetail.item.product_id, dataDetail.item.lot_no, dataDetail.item.unit_name)"
                                    class="pa-6 grad-success-bg white--text" title="ย้ายคลัง">
                                    <v-icon>mdi-arrow-up-left</v-icon>
                                    ย้ายคลัง
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
        </v-card>

        <!-- Dialog สำหรับย้ายคลัง -->
        <v-dialog v-model="move_stock" persistent max-width="650">
            <v-card>
                <v-form ref="add_form" @submit.prevent="save_data">
                    <v-card-title>
                        การย้ายคลัง (คงเหลือ {{ list_detail.quantity_get }} {{ item_unit }})
                    </v-card-title>

                    <v-card-text>
                        <div class="mb-6">
                            <div class="d-flex">
                                <v-icon>mdi-document</v-icon>
                                <div class="ml-1">คลังที่ต้องการย้าย</div>
                            </div>
                            <div class="grid_full">
                                <div class="mt-3 mr-1">
                                    <v-select color="#86bc3a" :items="items" item-text="name" item-value="id"
                                        label="กรุณาเลือกคลังที่ต้องการย้าย"
                                        :rules="[v => !!v || 'กรุณาเลือกคลังที่ต้องการย้าย']"
                                        v-model="list_detail.stock_select" hide-details="auto" required
                                        outlined></v-select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-6">
                            <div class="d-flex">
                                <v-icon>mdi-document</v-icon>
                                <div class="ml-1">จำนวนสินค้า</div>
                            </div>
                            <div class="grid_full">
                                <div class="mt-3 mr-1">
                                    <v-text-field color="#86bc3a" type="number" @keypress="onlyNumber($event)"
                                        label="กรุณากรอกจำนวนสินค้า" :rules="[v => !!v || 'กรุณากรอกจำนวนสินค้า']"
                                        hide-details="auto" required v-model="list_detail.qty" outlined></v-text-field>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="d-flex">
                                <v-icon>mdi-document</v-icon>
                                <div class="ml-1">สาเหตุการย้ายคลัง</div>
                            </div>
                            <div class="grid_full">
                                <div class="mt-3 mr-1">
                                    <v-textarea color="#86bc3a" outlined label="กรุณากรอกสาเหตุการย้ายคลัง"
                                        :rules="[v => !!v || 'กรุณากรอกสาเหตุการย้ายคลัง']" hide-details="auto" required
                                        v-model="list_detail.note"></v-textarea>
                                </div>
                            </div>
                        </div>
                    </v-card-text>
                    <v-spacer></v-spacer>
                    <div class="text-center pa-4">
                        <v-btn large class="grad-success-bg white--text mr-3" type="submit" style="font-size: 18px">
                            บันทึก
                        </v-btn>
                        <v-btn large class="grad-danger-bg white--text" type="button" style="font-size: 18px"
                            @click="move_stock = false">
                            ยกเลิก
                        </v-btn>
                    </div>
                </v-form>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { HTTP } from "@/axios";
import Swal from "sweetalert2";
import ImageHeader from '@/assets/loupe.png'
import ReturnHeader from "@/components/admin/stock/storage_return/header_return/ReturnHeader.vue";
import { formatNumber, onlyForNumber } from "@/js/handler";

export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    name: "Return_details_new",
    components: {
        ReturnHeader
    },
    data() {
        return {
            header_image: ImageHeader,
            loading_page: false,
            search: '',
            alert_success: false,
            typeReturn: null,
            selectedMonth: null,
            selectedYear: null,
            move_stock: false,
            item_unit: null,
            productList: [],
            months: [
                { name: 'มกราคม', value: 1 },
                { name: 'กุมภาพันธ์', value: 2 },
                { name: 'มีนาคม', value: 3 },
                { name: 'เมษายน', value: 4 },
                { name: 'พฤษภาคม', value: 5 },
                { name: 'มิถุนายน', value: 6 },
                { name: 'กรกฎาคม', value: 7 },
                { name: 'สิงหาคม', value: 8 },
                { name: 'กันยายน', value: 9 },
                { name: 'ตุลาคม', value: 10 },
                { name: 'พฤศจิกายน', value: 11 },
                { name: 'ธันวาคม', value: 12 }
            ],
            years: [],
            footer_Props: {
                'items-per-page-text': 'รายการต่อหน้า'
            },
            headers: [
                {
                    text: 'ล็อตสินค้า',
                    value: 'lot_no',
                    fixed: true,
                    width: '150px',
                },
                {
                    text: 'ชื่อสินค้า',
                    value: 'product_name',
                    fixed: true,
                    width: '300px',
                },
                {
                    text: 'วันหมดอายุ',
                    value: 'date_expired',
                    fixed: true,
                    width: '150px',
                },
                {
                    text: 'จำนวนคงเหลือ',
                    value: 'quantity',
                    fixed: true,
                    width: '170px',
                },
                {
                    text: 'หน่วยนับ',
                    value: 'unit_name',
                    fixed: true,
                    width: '150px',
                },
                {
                    text: 'หมายเหตุ',
                    value: 'cause_note',
                    sortable: false,
                    fixed: true,
                    width: '180px',
                },
                {
                    text: 'ซัพพลายเออร์',
                    value: 'supplier_name',
                    fixed: true,
                    width: '250px',
                },
                {
                    text: 'จัดการ',
                    value: '',
                    sortable: false,
                    fixed: true,
                    width: '120px',
                },
            ],
            items: [
                { id: 3, name: 'คลังหลัก' },
                { id: 4, name: 'คลังใกล้หมดอายุ' },
                { id: 5, name: 'คลังทิ้ง' },
            ],
            list_detail: {
                warehouse_id: null,
                product_id: null,
                lot_no: null,
                stock_select: null,
                qty: 1,
                note: null,
                quantity_get: null,
            },
        }
    },
    created() {
        // รับค่าจาก route params และ query
        this.typeReturn = parseInt(this.$route.params.type);
        this.selectedMonth = this.$route.query.month ? parseInt(this.$route.query.month) : null;
        this.selectedYear = this.$route.query.year ? parseInt(this.$route.query.year) + 543 : null;

        // สร้างรายการปี
        this.generateYears();

        // ตรวจสอบว่ามีข้อมูล type หรือไม่
        if (!this.typeReturn) {
            Swal.fire({
                title: 'ข้อมูลไม่ครบถ้วน',
                text: 'กรุณาเลือกประเภทสินค้า',
                icon: 'warning',
                confirmButtonText: 'ตกลง'
            }).then(() => {
                this.$router.push('/stock/storage/returnstorage');
            });
        } else {
            // โหลดข้อมูล
            this.loadData();
        }
    },
    methods: {
        formatDate(dateString) {
            if (!dateString) return '-';
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear() + 543; // แปลงเป็น พ.ศ.
            return `${day}/${month}/${year}`;
        },
        generateYears() {
            const currentYear = new Date().getFullYear();
            const startYear = currentYear - 5;
            const endYear = currentYear + 1;

            for (let year = endYear; year >= startYear; year--) {
                this.years.push(year + 543);
            }
        },
        getMonthName(monthValue) {
            const month = this.months.find(m => m.value === monthValue);
            return month ? month.name : '-';
        },
        getTypeName(type) {
            switch (type) {
                case 1:
                    return 'สินค้าไม่ได้สั่ง';
                case 2:
                    return 'สินค้าชำรุด';
                case 3:
                    return 'สินค้าเคลมใกล้หมดอายุ';
                default:
                    return '-';
            }
        },
        format_number(value) {
            return formatNumber(value);
        },
        onlyNumber(evt) {
            return onlyForNumber(evt);
        },
        loadData() {
            this.loading_page = true;
            HTTP.post('/inventory/returns/getreturnstorage', {
                type_return: this.typeReturn,
                month: this.selectedMonth,
                year: this.selectedYear ? this.selectedYear - 543 : null
            }).then((res) => {
                if (res.data.success === true) {
                    this.productList = res.data.object;
                } else {
                    Swal.fire({
                        title: 'เกิดข้อผิดพลาด',
                        text: res.data.message || 'ไม่สามารถโหลดข้อมูลได้',
                        icon: 'error',
                        confirmButtonText: 'ตกลง'
                    });
                }
                this.loading_page = false;
            }).catch((error) => {
                console.error('Error loading data:', error);
                Swal.fire({
                    title: 'เกิดข้อผิดพลาด',
                    text: 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                    icon: 'error',
                    confirmButtonText: 'ตกลง'
                });
                this.loading_page = false;
            });
        },
        goBack() {
            this.$router.push('/stock/storage/returnstorage');
        },
        get_move(quantity, warehouse_id, product_id, lot_no, unit_name) {
            this.move_stock = true;
            this.list_detail.quantity_get = quantity;
            this.list_detail.warehouse_id = warehouse_id;
            this.list_detail.product_id = product_id;
            this.list_detail.lot_no = lot_no;
            this.item_unit = unit_name;
        },
        save_data() {
            if (this.$refs.add_form.validate()) {
                if (this.list_detail.qty > 0 && this.list_detail.qty <= this.list_detail.quantity_get) {
                    HTTP.post('/inventory/returns/movestoragefromreturn', {
                        user_create: this.$store.state.userDetail.id,
                        user_name: this.$store.state.userDetail.name,
                        from_warehouse: 'คลังรอคืน',
                        warehouse_id: this.list_detail.warehouse_id,
                        product_id: this.list_detail.product_id,
                        lot_no: this.list_detail.lot_no,
                        stock_move_id: this.list_detail.stock_select,
                        qty: this.list_detail.qty,
                        cause_note: this.list_detail.note,
                    }).then((res) => {
                        if (res.data.success === true) {
                            this.move_stock = false;
                            this.alert_success = true;
                            setTimeout(() => this.alert_success = false, 3000);
                            setTimeout(() => this.loadData(), 1000);
                            this.list_detail.stock_select = null;
                            this.list_detail.qty = 1;
                            this.list_detail.note = null;
                        } else if (res.data.success === false) {
                            Swal.fire({
                                text: res.data.message,
                                icon: 'error',
                                showDenyButton: false,
                                showCancelButton: false,
                                confirmButtonText: `ตกลง`,
                                denyButtonText: `ยกเลิก`,
                            }).then(() => {
                                this.list_detail.qty = 1;
                            });
                        }
                    });
                } else {
                    Swal.fire({
                        text: 'จำนวนสินค้าที่ต้องการย้ายต้องมากกว่า 0 และไม่เกินจำนวนคงเหลือ!',
                        icon: 'error',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: `ตกลง`,
                        denyButtonText: `ยกเลิก`,
                    }).then(() => {
                        this.list_detail.qty = 1;
                    });
                }
            }
        }
    }
}
</script>

<style scoped>
.btn_size {
    font-size: 18px;
}

.grid_flex {
    display: flex;
}

.alert {
    position: fixed;
    top: 80px;
    right: 20px;
    z-index: 9999;
}

@media only screen and (max-width: 600px) {
    .grid_flex {
        display: grid;
        grid-template-columns: 100%;
    }

    .btn_mobile {
        width: 100% !important;
    }
}
</style>